export const access = (value: string, postfix = '') => {
  switch (value) {
    case 'admin':
      return 'مدیر ' + postfix;
    case 'customer':
      return 'کاربر ' + postfix;
    case 'sub-customer':
      return 'زیر مجموعه کاربر';
    default:
      return value;
  }
}
